import { LeftOutlined } from "@ant-design/icons";
import { NavBar } from "antd-mobile";
import "./style.scss";

const CustomNavbar = ({
  children,
  back = "",
  backIcon = false,
  left,
  onBack = () => {},
  right,
  customStyle = "",
}) => {
  return (
    <NavBar
      className={`custom-navbar ${customStyle}`}
      back={back}
      backIcon={backIcon ? <LeftOutlined className="back" onClick={onBack} /> : <></>}
      left={left}
      // onBack={onBack}
      right={right}
    >
      {children}
    </NavBar>
  );
};

export default CustomNavbar;
